import { Paper } from '@material-ui/core'
import React from 'react'
import { PaperProps } from '@material-ui/core/Paper'
import styled from '../../../theme'

type Type = React.ComponentType<PaperProps>
const TemplateSendModalWrapper: Type = styled(Paper)<PaperProps>`
  border: none;
  outline: none;
  max-width: 45em;
  min-width: 30em;
  background-color: white;
  padding: 16px;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    width: 95vw;
    max-height: 90vh;
    min-width: 0;
    overflow: auto;
    overscroll-behavior: contain;
  }
`

export default TemplateSendModalWrapper
